import React, { useEffect } from 'react';
import Hls from 'hls.js';
import './FullscreenVideo.css';

export default function FullscreenVideo({ src, onEnd }) {
  const videoRef = React.useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if(!video) return;

    let hls;

    if (src.endsWith('.m3u8')){
      if (Hls.isSupported()) {
        hls = new Hls({
          // 设置 HLS.js 的配置选项
          startLevel: 0,
          maxBufferLength: 10,
        });
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play().catch(error => console.log('Auto-play blocked:', error));
        });
      }
      // 如果浏览器支持原生 HLS
      else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
      }
    } else {
      // 如果是 MP4 或其他格式，直接设置视频源
      video.src = src;
    }
    
    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src]);
  
  
  return (
    <div className="video-overlay">
      <video
        ref={videoRef}
        className="fullscreen-video"
        autoPlay
        muted={false}
        onEnded={onEnd}
      /> 
    </div>
  );
}